/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 8/20/15.
 */
'use strict';
angular.module('prism-ui.components').directive('prismList', function () {
	return {
		restrict: 'E',
		require: ['ng-model', 'prismList'],
		templateUrl: 'components/visual/list/prism-list-template.html',
		controller: 'PrismListController',
		controllerAs: 'listController',
		scope: true,
		bindToController: {
			items: '=',
			labelField: '@',
			modelProp: '@',
			componentDisabled: '=ngDisabled'
		},
		link: function(scope, element, attrs, ctrls) {
			var ngModelCtrl = ctrls[0];
			var listController = ctrls[1];

			ngModelCtrl.$formatters.push(function (modelValue) {
				listController.selectedItem = modelValue;
				return modelValue;
			});

			listController.isItemSelected = function(item) {
				return listController.selectedItem === item[listController.modelProp];
			};

			listController.selectItem = function(item) {
				var viewValue = item[listController.modelProp];

				if(listController.selectedItem === viewValue) {
					listController.selectedItem = null;
				} else {
					listController.selectedItem = viewValue;
				}

				ngModelCtrl.$setViewValue(listController.selectedItem);
			};
		}
	};
});
